// extracted by mini-css-extract-plugin
export default {"root":"AdditionalMainDocument_root__ataxq"};